export class AreaEnermanModel {
    public profile_enabled: any[] = []; 
    public cdc_associated = [];
    public enable_disabled : any;
    public notes: string;  
}
